import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface LmpInfo {
  RmiCompanyId: string,
  RmiProvKeyId: string,
  RmiMembMpiNo: string,
  RmiLmpDate: string
}

export interface GetLmpDateResponse {
  RmiEstDueDate: null,
  RmiLmpDate: string
}

export const getLmpDate = (companyId: string, mpiNo: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_LMP_DATE_REQUEST });

  return api.eligibility.lmp.getDate(companyId, mpiNo)
    .then((res: any) => {

      dispatch({
        type: types.GET_LMP_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_LMP_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const saveLmpDate = (memberInfo: LmpInfo) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityLMP.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_LMP_DATE_REQUEST });

  const details = {
    RmiCompanyId: memberInfo.RmiCompanyId,
    RmiProvKeyId: memberInfo.RmiProvKeyId,
    RmiMembMpiNo: memberInfo.RmiMembMpiNo,
    RmiLmpDate: memberInfo.RmiLmpDate
  };

  return api.eligibility.lmp.saveDate(details)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_LMP_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_LMP_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
